import Vue from 'vue';

import NotificationCenter from './../notification_center/module';
import MobileReferralsVM from './../../user/referrals/mobile-referrals-vm';
import MobileScroll from './mobile-scroll';
import SearchServices from './../search/results/services';

export default {
  data() {
    return {
      skip_pjax_destroy: true,
      global_mode: true,
      search_query: null,
      search_results: [],
      search_has_focus: false,
      show_mobile_search_modal: false,
      search_performed: false,
      search_results_loading: false,
      filter: 'all',
      page: 1,
      results_per_page: 10,

      primary_action: {
        label: 'Change Me',
        is_active: true,
      },

      expandable: true,

      nav_items: [
        {
          icon_class: 'kf-dashboard',
          label: 'Change Me',
          is_active: true,
        }
      ],

      modernizr: Modernizr,
    }
  },

  methods: {
    refreshNotificationCenter() {
      document.querySelectorAll('.js_notification-center-target')
        .forEach(el => NotificationCenter.refresh(el))
    },

    showReferralModal() {
      this.referrals.show();
    },

    searchOnEnter() {
      if (this.trimmedQuery) {
        Kadenze.Analytics.track('search', 'query', { query: this.trimmedQuery });
        Kadenze.UIUtil.showLoadingIndicator();
        window.location = Kadenze.Routes.search_path({ q: this.trimmedQuery });
      }
    },

    mobileSearchOnEnter(){
      if (this.trimmedQuery) {
        Kadenze.Analytics.track('search', 'query', { query: this.trimmedQuery });
        Kadenze.UIUtil.showLoadingIndicator('.mobile-modal');

        this.search_query = this.trimmedQuery;
        this.loadResults(false);

        document.getElementById('mobile-nav-search-field').blur()
      }
    },

    searchClearOnClick() {
      this.search_query = '';
      document.getElementById('top-nav__search_field').focus();
    },

    mobileSearchClearOnClick() {
      this.search_query = '';
      document.getElementById('mobile-nav-search-field').focus();
    },

    setSearchFocus(state) {
      const $nav = $('.js_top-nav-main');
      const $fieldWrapper = $('#top-nav__search');
      const $field = $('#top-nav__search_field');

      this.search_has_focus = state;

      if (state) {
        TweenLite.to($nav, 0.5, { opacity: 0 });

        TweenLite.to($fieldWrapper, 0.5, {
          width: '100%',
          ease: Quad.easeInOut
        });

        $field.select();
      } else {
        TweenLite.to($nav, 0.5, { opacity: 1 });
        TweenLite.to($fieldWrapper, 0.5, { width: 280 });
      }
    },

    showHideMobileSearch(state) {
      if (state) {
        Kadenze.Layout.disableMainContentScroll(true);
        this.show_mobile_search_modal = true;
        setTimeout(this.attachSearchScrollEventListener, 100);
      } else {
        Kadenze.Layout.restoreMainContentScroll();
        this.show_mobile_search_modal = false;
      }
    },

    highlightValue(result, key) {
      return SearchServices.highlightValue(result, key);
    },

    highlightType(result) {
      return SearchServices.highlightType(result);
    },

    highlightInstructors(result) {
      return SearchServices.highlightInstructors(result);
    },

    highlightDescription(result) {
      return SearchServices.highlightDescription(result);
    },

    attachSearchScrollEventListener() {
      $('.js_search__results-wrapper')
        .off('scroll.searchResultsLoadMore')
        .on('scroll.searchResultsLoadMore', _.debounce(() => {
        const $scrollTarget = $('#mobileLoadMoreResults')
        const topOffset = $scrollTarget.offset().top
        const windowHeight = $(window).height();

        if (topOffset < (windowHeight + 30))
          this.loadMoreResults();
      }, 250));
    },

    searchResultOnClick(result) {
      SearchServices.searchResultOnClick(result,this.search_query);
    },

    loadResults(append, givenUrl) {
      if (append)
        Kadenze.UIUtil.showLoadingIndicator($('.mobile-search .search__results'));

      this.search_performed = true;
      this.search_results_loading = true;
      this.page = append ? this.page += 1 : this.page;

      const url = givenUrl || Kadenze.Routes.search_path({
        q: this.search_query,
        page: this.page,
        per_page: this.results_per_page
      });

      const request = new Kadenze.AjaxRequest({
        type: 'GET',
        url,
        dataAsJSON: false,
        timeout: 60000
      });

      request.done(data => {
        Kadenze.UIUtil.hideLoadingIndicator($('.mobile-modal'));
        Kadenze.UIUtil.hideLoadingIndicator($('.mobile-search .search__results'));

        if (append) {
          this.search_results = this.search_results.concat(data.results);
        } else {
          this.search_results = data.results;
        }

        this.search_results_loading = false;
      });
    },

    loadMoreResults() {
      this.loadResults(true);
    }
  },

  computed: {
    trimmedQuery() {
      const strTrimmedQuery = this.search_query.trim()

      const isEmpty = obj => {
        return [Object, Array].includes((obj || {}).constructor) &&
          !Object.entries((obj || {})).length;
      }

      if (!isEmpty(strTrimmedQuery))
        return strTrimmedQuery
    },

    filteredResults() {
      if (this.filter === 'all') {
        return this.search_results;
      } else {
        return this.search_results.filter(r => r.type === this.filter)
      }
    }
  },

  watch: {
    global_mode(enabled) {
      if (enabled)
        setTimeout(this.refreshNotificationCenter, 300);
    }
  },

  mounted() {
    Kadenze.MainMenu.init();

    if (Kadenze.KadenzePublicHeroSlider)
      Kadenze.KadenzePublicHeroSlider.init()

    const q = Kadenze.Util.getQueryVariable('q');

    let strQuery;

    if (q)
      strQuery = q.replace(/\+/g , ' ');

    this.search_query = strQuery || null;
    this.refreshNotificationCenter();

    this.$bus.$on('top_nav_render', (config) => {
      this.global_mode = false;
      this.primary_action = config.primary_action;
      this.nav_items = config.nav_items;
    });

    this.$bus.$on('top_nav_update', (config) => {
      this.global_mode = false;

      _.extend(this.primary_action, config.primary_action);

      config.nav_items.forEach((item, index) => {
        _.extend(this.nav_items[index], item);
      });
    });

    this.$bus.$on('top_nav_clear', () => {
      this.global_mode = true;
      this.nav_items = [];
    });

    this.$bus.$on('hide_expand_arrow', () => {
      Kadenze.LeftNav.desktopCollapse();
      this.expandable = false;
    });

    if (document.getElementById('js-nav-referral-modal')) {
      this.referrals = new Vue(MobileReferralsVM);
      this.referrals.$mount(document.getElementById('js-nav-referral-modal'));
    }

    if (Kadenze.UIUtil.isMobileOrTablet()) {
      MobileScroll.init();
    }
  }
};
